import { useQuery } from 'react-query';
import { network } from 'services/network';

const getLogicCheckerSummary = (params) => {
    return network.post('api/bo/getLogicCheckerSummary', params).then((response) => {
        return response.data;
    });
};
export const useQueryGetLogicCheckerSummary = (params) => {
    return useQuery<ILogicCheckerSummaryResponse, QueryError>(
        ['getLogicCheckerSummary', params],
        () => getLogicCheckerSummary(params),
        {
            enabled: Boolean(params.fileMetaDataId),
        },
    );
};

export interface ILogicCheckerSummaryResponse {
    title: string;
    totalActivities: number;
    totalMilestones: number;
    maxWBSLevel: number;
    overallScore: string;
    overallScoreColor: string;
    notInScoreList: {
        categoryName: string;
        checkName: string;
    }[];
    info: IToolTip;
    inScoreNumber: number;
}
